import { BaseCaller } from "./api";

export default class ProductAPI {
  private caller: BaseCaller;

  constructor(caller: BaseCaller) {
    this.caller = caller;
  }

  public list(companyId: number): Promise<any> {
    return this.caller.get(`company/${companyId}/products/all`);
  }

  public filter(
    companyId: number,
    search: string,
    filter: string
  ): Promise<any> {
    const squery =
      search.trim().toUpperCase().length > 0
        ? `?search=${search.trim().toUpperCase()}`
        : "?";
    const fquery =
      filter.trim().toUpperCase().length > 0
        ? `&filter=${filter.trim().toUpperCase()}`
        : "";
    return this.caller.get(
      `company/${companyId}/products/filter${squery}${fquery}`
    );
  }

  public listAvailable(companyId: number): Promise<any> {
    return this.caller.get(`company/${companyId}/products/`);
  }

  save(companyId: number, data: any) {
    if (data.product.id) {
      return this.caller.put(
        `company/${companyId}/product/${data.product.id}`,
        data.product
      );
    }
    return this.caller.post(
      `company/${companyId}/categories/${data.category}/products`,
      data.product
    );
  }

  disable(companyId: number, productId: number) {
    return this.caller.post(
      `company/${companyId}/product/${productId}/inactivate`,
      {}
    );
  }

  addPhoto(companyId: number, productId: number, file: any) {
    return this.caller.postFormFile(
      `company/${companyId}/product/${productId}/photo`,
      file
    );
  }
}



// WEBPACK FOOTER //
// ./src/api/product-api.ts